import React from 'react';

interface Props {
  wrapperStyle?: React.CSSProperties;
  children: React.ReactNode;
}

export const LocationIconWrapper: React.FC<Props> = ({ wrapperStyle, children }) => {
  return (
    <div style={{ ...styles.iconWrapper, ...wrapperStyle }}>
      {children}
    </div>
  );
};

const styles = {
  iconWrapper: {
    width: 36,
    height: 36,
    backgroundColor: '#F0F0F0',
    borderColor: '#00F2F2',
    borderWidth: 2,
    borderRadius: 6,
    alignItems: 'center', // Not directly applicable in React, need to be handled via CSS
    justifyContent: 'center', // Not directly applicable in React, need to be handled via CSS
    marginRight: 15,
    display: 'flex', // This replaces alignItems and justifyContent
  },
};